import { Dispatch } from '../../../../../../../types/actions';
import { isOpenSetAction } from '../actions/isOpenSetAction';

export const closeNavPanel = () => {
    return (dispatch: Dispatch) => {
        dispatch(isOpenSetAction(false));
    }
}
